module.exports = __webpack_public_path__ + "static/media/download.75e189ef.svg";